import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class LedgerContractNoteUseCase extends BaseUseCase {
    constructor(LedgerRepo) {
        super();
        this.LedgerRepo = LedgerRepo;
    }
    async fetchResult(req) {
        return await this.LedgerRepo.contractNote(req);
    }
}
export default LedgerContractNoteUseCase;
